import {
    IOrderOtherSectionsButtonsLogic
} from "../../components/order_entry/OrderOtherSectionsButtons/IOrderOtherSectionsButtonsLogic";
import {useContext, useMemo} from "react";
import OrderStatesEnum from "../../models/OrderStatesEnum";
import OrderEntryService from "../../services/OrderEntryService";
import IOrderUI from "../../models/IOrderUI";
import SupplierContext from "../../contexts/SupplierContext";
import UserContext from "../../contexts/UserContext";
import UserTypesEnum from "../../models/UserTypesEnum";

export const useOrderOtherSectionsButtonsLogic = (props: {order: IOrderUI}): IOrderOtherSectionsButtonsLogic => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const logic = useMemo(() => {
        const defaultLogic: IOrderOtherSectionsButtonsLogic = {
            showPickPackButtons: false,
            showManualShipBtns: false,
            showLocalDeliveryBtn: false,
            showLocalPickupBtn: false,
            showBackorderBtn: false,
            showPurchaseOrderBtn: false,
            hideQuoteOwButtons: false,
            showDownloadPdfButton: false,
        }

        const { currentStep, nextStep } = OrderEntryService.getCurrentAndNextOrderSteps(props.order, supplierModel);

        let showPickPackButtons = false;
        let showManualShipBtns = false;
        let showLocalPickupBtn = false;
        let showLocalDeliveryBtn = false;
        let showDownloadPdfButton = false;
        let hideQuoteOwButtons = true;

            if (supplierModel.show_download_pdf) {
            showDownloadPdfButton = true;
        }

        if (!supplierModel.Supplier_Integration.qbo_hide_quote_ow_btns && props.order.is_quote) {
            hideQuoteOwButtons = false;
        }

        if (userModel.isSupplierUser) {
            let isVisible = false;

            if (
                userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ||
                userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.SHIP_MGMT ||
                userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ORDER_MGMT ||
                userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.INVENTORY_MGMT
            ) {
                if (nextStep?.order_state_id === OrderStatesEnum.SHIPPED && !nextStep.autoCreateShipment) {
                    isVisible = true;
                }

                if (currentStep?.allowCreateFulfillment) {
                    isVisible = true;
                }
            }

            showManualShipBtns = isVisible;
        }

        if (showManualShipBtns) {
            if (props.order.is_local_pickup) {
                showLocalPickupBtn = true;
                showLocalDeliveryBtn = false;
            }

            if (props.order.is_local_delivery) {
                showLocalDeliveryBtn = true;
                showLocalPickupBtn = false;
            }
        }

        const showBackorderBtn = ((supplierModel.has_backorders) &&
            !!nextStep &&
            !props.order.is_quote &&
            !props.order.is_template &&
            userModel.isSupplierUser &&
            userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN) || false;

        let showPurchaseOrderBtn = false;

        if (supplierModel.has_purchase_orders &&
            props.order.order_state_id !== OrderStatesEnum.PRELIMINARY &&
            !!nextStep &&
            supplierModel.has_create_po_from_orders &&
            userModel.isSupplierUser &&
            userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN
        ) {
            showPurchaseOrderBtn = true;
        }

        // Pick Pack Buttons
        if (
            userModel.isSupplierUser &&
            !supplierModel.has_pick_list_management &&
            userModel.supplierUserToken?.User_Type?.id !== UserTypesEnum.SALES &&
            props.order.order_state_id !== OrderStatesEnum.PRELIMINARY
        ) {
            showPickPackButtons = true;
        }

        if (supplierModel.settings?.screens?.order_entry?.hide_pick_pack_buttons) {
            showPickPackButtons = false;
        }

        return {
            ...defaultLogic,
            showPickPackButtons,
            showManualShipBtns,
            showLocalPickupBtn,
            showLocalDeliveryBtn,
            showBackorderBtn,
            showPurchaseOrderBtn,
            showDownloadPdfButton,
            hideQuoteOwButtons
        }
    }, [props.order]);

    return logic;
}
